import React from 'react';
import { useDispatch } from 'react-redux';

import { Link as RouterLink } from 'react-router-dom';
import { Paper, Box, Button, Link, Grid, Typography } from '@material-ui/core';
import { Form } from 'react-final-form';
import { TextField } from 'mui-rff';

import { CountryCodeSelect } from 'components/elements';
import { INITIAL_VALUES, validate } from './helpers';
import { signIn } from 'store/actions';

import { convertApiFormErrors } from 'helpers';
import { APP_PATHS } from 'components/routes/paths';
import { useIsDesktop, useTranslations } from 'components/utilities';

const SignInForm = ({ history }) => {
	const { t, i18n } = useTranslations();
	const dispatch = useDispatch();
	const { VERIFICATION, SIGN_UP, FORGOT_PASSWORD } = APP_PATHS;

	const handleSubmit = async (values) => {
		let apiErrors = {};
		await signIn(values, (errors) => {
			if (errors.type === 'verification') {
				history.push(
					VERIFICATION.replace(':id', errors.user_id).replace(
						':token',
						errors.token
					)
				);
			} else {
				apiErrors = convertApiFormErrors(errors);
			}
		})(dispatch);
		return apiErrors;
	};

	const direction = i18n.language === 'en' ? 'row' : 'row-reverse';

	const isDesktop = useIsDesktop();

	const boxPaddings = {
		py: isDesktop ? 6 : 3,
		px: isDesktop ? 12 : 3,
	};

	return (
		<Paper>
			<Box {...boxPaddings}>
				<Form
					onSubmit={handleSubmit}
					validate={validate(t)}
					initialValues={INITIAL_VALUES}
				>
					{({ handleSubmit, submitting }) => (
						<form onSubmit={handleSubmit} autoComplete="off">
							<Grid
								container
								spacing={1}
								alignItems="center"
								direction={direction}
							>
								<Grid item xs={4} md={3}>
									<CountryCodeSelect
										variant="outlined"
										name="country_code"
										disabled={submitting}
									/>
								</Grid>
								<Grid item xs={8} md={9}>
									<TextField
										autoComplete="new-password"
										variant="outlined"
										label={t('login.phoneLabel')}
										name="phone"
										fullWidth
										disabled={submitting}
									/>
								</Grid>
							</Grid>

							<TextField
								autoComplete="new-password"
								variant="outlined"
								label={t('login.password')}
								name="password"
								type="password"
								fullWidth
								margin="normal"
								disabled={submitting}
							/>

							<Box mt={isDesktop ? 5 : 2}>
								<Link
									color="primary"
									component={RouterLink}
									to={FORGOT_PASSWORD}
									align="right"
									variant="body1"
								>
									{t('login.forgetPasswordLink')}
								</Link>
							</Box>

							<Box pt={isDesktop ? 12 : 4}>
								<Button
									type="submit"
									variant="contained"
									color="primary"
									fullWidth
									size={isDesktop ? 'large' : 'medium'}
									disabled={submitting}
								>
									{t('login.buttonSendText')}
								</Button>
							</Box>

							<Box pt={isDesktop ? 12 : 4}>
								<Typography
									align="center"
									variant={isDesktop ? 'body1' : 'body2'}
								>
									{t('login.registerLabel')}{' '}
									<Link component={RouterLink} to={SIGN_UP}>
										{t('login.registerLink')}
									</Link>
								</Typography>
							</Box>
						</form>
					)}
				</Form>
			</Box>
		</Paper>
	);
};

export default SignInForm;
